(function () {
    "use strict";

    angular.module("app").factory("contactPersonApi", ContactPersonApiFactory);

    ContactPersonApiFactory.$inject = ["apiClientFactory"];
    function ContactPersonApiFactory(apiClientFactory) {

        const routePrefix = "api/contact-person/";

        return {
            AcceptRequest: apiClientFactory.patch(routePrefix + "requests/accept/"),
            AddComment: apiClientFactory.post(routePrefix + "request-comments/"),
            Get: apiClientFactory.get(routePrefix + "requests/"),
            GetComments: apiClientFactory.post(routePrefix + "comments/"),
            RegisterVerificationResult: apiClientFactory.patch(routePrefix + "requests/result/"),
            RejectRequest: apiClientFactory.patch(routePrefix + "requests/reject/"),
            ReturnRequest: apiClientFactory.put(routePrefix + "requests/return/"),
            SaveJusticationValidation: apiClientFactory.put(routePrefix + "save-justification-validation/"),
            SaveRequest: apiClientFactory.put(routePrefix + "requests/save/"),
            SaveRequestValidation: apiClientFactory.put(routePrefix + "save-validation/"),
            SearchRequests: apiClientFactory.post(routePrefix + "requests/"),
            StartVerifications: apiClientFactory.patch(routePrefix + "requests/start-verifications/"),
            SubmitRequest: apiClientFactory.put(routePrefix + "requests/submit/"),
            getEmails: (id, onSuccess, onError, finallyCalback) => apiClientFactory.get(`${routePrefix}requests/${id}/emails`)("", onSuccess, onError, finallyCalback),
        };
    }
})();
